import { inject, Injectable } from '@angular/core';
import { AlertService } from '../shared/alert/alert.service';
import { AlertEnum } from '../shared/alert/alert.enum';

declare var webkitSpeechRecognition: any;
@Injectable({
  providedIn: 'root'
})
export class SpeechService {
  #alertService = inject(AlertService);
  #attempts = 0;

  listen(lang: string): Promise<string> {
    const recognition = new webkitSpeechRecognition();
    recognition.lang = lang;
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.start();

    return new Promise((resolve, reject) => {
      recognition.onresult = (event: any) => {
        resolve(event.results[0][0].transcript);
        recognition.abort();
        this.#attempts = 0;
      };

      recognition.onerror = (event: any) => {
        this.#attempts++;
        if (event.error === 'no-speech') {
          let message = 'No speech detected. Please try again.';
          if (this.#attempts > 2) {
            message = 'No speech detected. Possible problems: 1. Ensure you are speaking loud and clearly. 2. Ensure that your browser has permission to access the microphone. You can check this in your browser settings.'
          }
          this.#alertService.showAlert({
            message,
            type: AlertEnum.error,
          });
        }
        reject(event.error);
      };
    });
  }
}
